export const dalepostBrand={
  id:'dalepost',
  name:'DalePost',
  monogram:'D',
  primary:'#202b25',
  accent:'#c99b5a',
  voice:'Confident,direct,and ready to publish.'
};

export const dalepostPosts=[
  {
    id:601,
    brandId:'dalepost',
    prompt:'Explain how DalePost turns an idea into a finished social post',
    headline:'One idea. Four beats. Ready to post.',
    supporting:'Type it,shape it,review it,and move on to the next thing.',
    caption:{
      instagram:'Type an idea → get an on-brand draft → review and approve → ready to post. That is the DalePost loop. Less designing from scratch. More publishing with intention. #DalePost #ContentWorkflow #JustPostIt',
      linkedin:'DalePost keeps the content workflow simple: start with one idea,turn it into an on-brand draft,review the result,and approve it when it feels right. The goal is not more content busywork. It is a clearer path from thought to post.',
      facebook:'The DalePost workflow is simple: type an idea,let the draft take shape,review it,and approve it. Four focused steps between “I should post something” and a finished post ready for your audience.'
    },
    image:'https://images.unsplash.com/photo-1496181133206-80ce9b88a853?auto=format&fit=crop&w=1200&q=80',
    status:'posted',
    postedDate:'2025-06-16',
    scheduledDate:null,
    rejectionReason:'',
    createdAt:'June 16'
  },
  {
    id:602,
    brandId:'dalepost',
    prompt:'Contrast manually designing every post with using DalePost',
    headline:'Stop redesigning the same post.',
    supporting:'One line in. Finished,on-brand content out.',
    caption:{
      instagram:'The old way: hours in Canva,another blank canvas,and a redesign from scratch. The DalePost way: one line in,a finished post out. Just post it. #DalePost #ContentCreation #JustPostIt',
      linkedin:'The old content workflow often means opening Canva,starting from a blank canvas,rebuilding the same visual system,and losing hours before the copy is even ready. DalePost turns one clear idea into a finished,on-brand post so you can spend that time running the business.',
      facebook:'Before DalePost: hours in Canva,starting over every time,and wondering why one post took all afternoon. After DalePost: one line in,a polished post out. Your next idea should not need another blank canvas.'
    },
    image:'https://images.unsplash.com/photo-1497366811353-6870744d04b2?auto=format&fit=crop&w=1200&q=80',
    status:'approved',
    scheduledDate:'2025-07-03',
    rejectionReason:'',
    createdAt:'June 14'
  },
  {
    id:603,
    brandId:'dalepost',
    prompt:'Show how DalePost manages multiple brands separately',
    headline:'More brands. One calmer workspace.',
    supporting:'Keep every voice,palette,and point of view exactly where it belongs.',
    caption:{
      instagram:'Running more than one brand? Switch between workspaces without mixing the voices. Each brand keeps its own colors,creative direction,and way of showing up. #DalePost #MultiBrand #AgencyLife',
      linkedin:'Managing multiple brands should not mean keeping separate notes for every voice,palette,and content rule. DalePost gives each brand its own workspace while keeping the entire content operation in one place — built for agencies and entrepreneurs with more than one business.',
      facebook:'One account can hold more than one brand without blending them together. Keep each voice,each color palette,and each creative direction separate — then switch between them when the next idea arrives.'
    },
    image:'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=1200&q=80',
    status:'draft',
    scheduledDate:null,
    rejectionReason:'',
    createdAt:'June 12'
  }
];